import React from 'react'
import {NavbarCloseOnly} from '../components/Properties/Navbar/Navbar'
import PromoCodeDetailPage from '../components/PromoCodePage/PromoCodeDetail'
function PromoCodeDetail() {
    return (
        <div className="container body-content mobile-view">            
            <PromoCodeDetailPage/>
        </div>
    )
}

export default PromoCodeDetail
